const verifyIdentityStrings = {
  buttons: {
    goToLogin: 'Go to login',
    contactUs: 'Contact us',
    done: 'Done',
  },
  tooManyRequests: {
    header: 'Too many link requests',
    body: 'You’ve requested too many links. Please  try again later.',
  },
  linkExpired: {
    header: 'This link has expired',
    body: 'Please try to log in again.',
  },
  invalidLink: {
    header: 'This link is invalid',
    body: 'Please try to log in again.',
  },
  unableToProcess: {
    header: 'Unable to process your request.',
    body: 'Please contact customer support for further assistance or try again later.',
  },
};

export default verifyIdentityStrings;
